export default __webpack_public_path__ + "static/media/green-camera.2f31bd02.gif";